// extracted by mini-css-extract-plugin
module.exports = {"FormSection1":"RatingForm_FormSection1__2byxS","Form":"RatingForm_Form__1YKJi","Button":"RatingForm_Button__2eU_n"};